<template>
  <div class="box">
    <HeaderTop></HeaderTop>
    <img src="../../../assets/images/503.png" alt="图片缺失" />
    <div class="tip">
      <p>抱歉，服务器不可访问</p>
      <div>
        <button class="backIndex" @click="backIndex">
          返回商城首页
        </button>
        <button class="backLast" @click="backLast">刷新({{ num }})</button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTop from '../common/header-top.vue'
export default {
  components: {
    HeaderTop
  },
  data() {
    return {
      num: 60
    }
  },
  created() {
    this.backByself()
  },
  methods: {
    backIndex() {
      this.$router.push({ path: '/' })
    },
    backLast() {
      window.history.go(-1)
    },
    backByself() {
      let timer = setInterval(() => {
        this.num--
        console.log(this.num)
        if (this.num <= 0) {
          clearInterval(timer)
          window.history.go(-1)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  .tip {
    width: 350px;
    height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-left: 50%;
    transform: translate(-50%, -100%);
    p {
      font-size: 24px;
      color: #979797;
    }
    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 24px;
      button {
        border-radius: 25px;
        cursor: pointer;
        height: 50px;
        text-align: center;
      }
      .backIndex {
        width: 160px;
        background: #1a50f0;
        color: #fff;
      }
      .backLast {
        width: 150px;
        border: 1px solid #1a50f0;
        background: #fff;
      }
    }
  }
}
</style>
